import ProductPricePrimitive from '@repo/ui/src/components/ProductPrice';

export default ProductPricePrimitive;
